class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector('#price-min') || document.querySelector('#FacetFiltersFormMobile #price-min');
    this.maxInput = this.querySelector('#price-max') || document.querySelector('#FacetFiltersFormMobile #price-max');
    this.minSlider = this.querySelector('#price-slider-min') || document.querySelector('#FacetFiltersFormMobile #price-slider-min');
    this.maxSlider = this.querySelector('#price-slider-max') || document.querySelector('#FacetFiltersFormMobile #price-slider-max');

    this.fill = this.querySelector('.price-range__fill') || 
                this.querySelector('.range-slider__fill') || 
                this.querySelector('.slider-fill') || 
                this.querySelector('.price-range-fill') || 
                document.querySelector('.price-range__fill') || 
                document.querySelector('.range-slider__fill') || 
                document.querySelector('.slider-fill') || 
                document.querySelector('.price-range-fil');

    this.facetFiltersForm = document.querySelector('facet-filters-form');

    if (!this.fill) {
      console.error('PriceRange: Geen fill-element gevonden met bekende selectors');
    }

    if (this.minSlider && this.maxSlider) {
      this.minSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.maxSlider.addEventListener('input', this.onSliderInput.bind(this));
      this.minSlider.addEventListener('change', this.onSliderChange.bind(this));
      this.maxSlider.addEventListener('change', this.onSliderChange.bind(this));
      console.log('PriceRange: Slider event listeners toegevoegd');
    }

    // Definieer debounce functie lokaal als deze niet globaal beschikbaar is
    this.debounce = (func, delay) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
      };
    };  

    if (this.minInput && this.maxInput) {
        this.debouncedOnInputChange = this.debounce(this.onInputChange.bind(this), 1000); // 1000ms debounce
        this.minInput.addEventListener('input', this.debouncedOnInputChange);
        this.maxInput.addEventListener('input', this.debouncedOnInputChange);
        this.minInput.addEventListener('change', this.onInputChange.bind(this));
        this.maxInput.addEventListener('change', this.onInputChange.bind(this));
        console.log('PriceRange: Input event listeners toegevoegd voor minInput en maxInput');
      } else {
        console.warn('PriceRange: minInput of maxInput niet gevonden');
      }
    }

  connectedCallback() {
    if (this.minInput && this.maxInput && this.facetFiltersForm) {
      // Wacht op het 'filters-updated' event om updateFill aan te roepen
      document.addEventListener('filters-updated', () => {
        console.log('PriceRange: filters-updated event received, calling updateFill');
        this.updateFill();
      }, { once: true });
    } else {
      console.warn('PriceRange: Niet alle elementen klaar in connectedCallback', {
        minInput: !!this.minInput,
        maxInput: !!this.maxInput,
        facetFiltersForm: !!this.facetFiltersForm
      });
    }
  }

  onSliderInput(event) {
    const value = parseFloat(event.target.value);
    const isMinSlider = event.target === this.minSlider;

    if (isMinSlider) {
      if (value > parseFloat(this.maxSlider.value)) {
        this.minSlider.value = this.maxSlider.value;
      }
    } else {
      if (value < parseFloat(this.minSlider.value)) {
        this.maxSlider.value = this.minSlider.value;
      }
    }

    this.minInput.value = this.minSlider.value;
    this.maxInput.value = this.maxSlider.value;
    this.updateFill();
    console.log(`test1`);
  }

  onSliderChange(event) {
    this.dispatchFormEvent('change', event.target === this.minSlider ? 'price-slider-min' : 'price-slider-max');
    console.log(`test2`);
  }

  onInputChange(event) {
    const value = parseFloat(event.target.value);
    const isMinInput = event.target === this.minInput;
  
    // Log alle events voor debugging
    console.log('onInputChange debug:', {
      eventType: event.type,
      targetId: event.target.id,
      value: event.target.value,
      parsedValue: value,
      minInputValue: this.minInput.value,
      maxInputValue: this.maxInput.value,
      minSliderValue: this.minSlider.value,
      maxSliderValue: this.maxSlider.value
    });
  
    // Voor input events (gedebonuceerd): update alleen sliders en fill, geen validatie
    if (event.type === 'input') {
      if (isMinInput && !isNaN(value)) {
        this.minSlider.value = value;
      } else if (!isMinInput && !isNaN(value)) {
        this.maxSlider.value = value;
      }
      this.updateFill();
      console.log(`PriceRange: onInputChange (input) - min: ${this.minInput.value}, max: ${this.maxInput.value}`);
      return;
    }
  
    // Voor change events: voer volledige validatie uit
    if (isNaN(value)) {
      console.warn('PriceRange: Ongeldige invoer, reset naar standaardwaarde', event.target.value);
      if (isMinInput) {
        this.minInput.value = parseFloat(this.minInput.getAttribute('min')) || 0;
        this.minSlider.value = this.minInput.value;
      } else {
        this.maxInput.value = parseFloat(this.maxInput.getAttribute('max')) || 100;
        this.maxSlider.value = this.maxInput.value;
      }
      this.updateFill();
      this.dispatchFormEvent('change', isMinInput ? 'price-min' : 'price-max');
      return;
    }
  
    // Validatie voor min en max
    if (isMinInput) {
      const maxValue = parseFloat(this.maxInput.value) || parseFloat(this.maxInput.getAttribute('max')) || Infinity;
      console.log('Validating minInput:', { value, maxValue });
      if (value > maxValue) {
        this.minInput.value = maxValue; // Zet min gelijk aan max
        console.log(`PriceRange: minInput aangepast naar ${maxValue} omdat waarde (${value}) te hoog was`);
      }
    } else {
      const minValue = parseFloat(this.minInput.value) || parseFloat(this.minInput.getAttribute('min')) || 0;
      console.log('Validating maxInput:', { value, minValue });
      if (value < minValue) {
        this.maxInput.value = minValue; // Zet max gelijk aan min
        console.log(`PriceRange: maxInput aangepast naar ${minValue} omdat waarde (${value}) te laag was`);
      }
    }
  
    // Synchroniseer sliders
    this.minSlider.value = this.minInput.value;
    this.maxSlider.value = this.maxInput.value;
  
    // Extra validatie om te garanderen dat max >= min
    const finalMin = parseFloat(this.minInput.value);
    const finalMax = parseFloat(this.maxInput.value);
    if (finalMax < finalMin) {
      console.log(`PriceRange: Correcting invalid range - max (${finalMax}) < min (${finalMin})`);
      this.maxInput.value = finalMin;
      this.maxSlider.value = finalMin;
    } else if (finalMin > finalMax) {
      console.log(`PriceRange: Correcting invalid range - min (${finalMin}) > max (${finalMax})`);
      this.minInput.value = finalMax;
      this.minSlider.value = finalMax;
    }
  
    this.updateFill();
    this.dispatchFormEvent('change', isMinInput ? 'price-min' : 'price-max');
    console.log(`PriceRange: onInputChange (change) - final min: ${this.minInput.value}, final max: ${this.maxInput.value}`);
  }

  dispatchFormEvent(eventType, targetId) {
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event(eventType, { bubbles: true }));
      console.log(`${eventType} event dispatched for ${targetId}`);
    }
  }

  updateFill() {
    console.log('updateFill called');

    if (!this.fill) {
      console.warn('PriceRange: Fill element not found in updateFill');
      return;
    }

    if (!this.minInput || !this.maxInput) {
      console.warn('PriceRange: Missing minInput or maxInput in updateFill');
      return;
    }

    const min = parseFloat(this.minInput.value) || 0;
    const max = parseFloat(this.maxInput.value) || 0;

    const minRange = this.facetFiltersForm && this.facetFiltersForm.currentPriceRange 
      ? this.facetFiltersForm.currentPriceRange.min 
      : parseFloat(this.minInput.getAttribute('min')) || 0;
    const maxRange = this.facetFiltersForm && this.facetFiltersForm.currentPriceRange 
      ? this.facetFiltersForm.currentPriceRange.max 
      : parseFloat(this.maxInput.getAttribute('max')) || 100;

    console.log('updateFill debug:', {
      minInputValue: this.minInput.value,
      maxInputValue: this.maxInput.value,
      min,
      max,
      minRange,
      maxRange,
      facetFiltersFormExists: !!this.facetFiltersForm,
      currentPriceRange: this.facetFiltersForm?.currentPriceRange
    });

    if (maxRange === minRange) {
      console.warn('PriceRange: maxRange equals minRange, setting fill to 0');
      this.fill.style.left = '0%';
      this.fill.style.width = '0%';
      return;
    }

    const left = ((min - minRange) / (maxRange - minRange)) * 100;
    const width = ((max - min) / (maxRange - minRange)) * 100;

    const clampedLeft = Math.max(0, Math.min(left, 100));
    const clampedWidth = Math.max(0, Math.min(width, 100 - clampedLeft));

    this.fill.style.left = `${clampedLeft}%`;
    this.fill.style.width = `${clampedWidth}%`;

    console.log('Fill updated:', {
      min,
      max,
      minRange,
      maxRange,
      left: `${clampedLeft}%`,
      width: `${clampedWidth}%`
    });
  }
}

customElements.define('price-range', PriceRange);

// Gedeelde staat voor alle instanties
const sharedState = {
  originalPriceRange: { min: 0, max: 800 },
  currentPriceRange: { min: 0, max: 800 },
  dynamicPriceRange: { min: 0, max: 800 },
  lastPriceFilter: { min: null, max: null }
};

// Storefront API-configuratie
const STOREFRONT_API_TOKEN = window.STOREFRONT_API_TOKEN || 'a5cb00b8b446acc113a148e1ded70bb6';
const STOREFRONT_API_URL = 'https://enisto.com/api/2023-10/graphql.json';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleFiltersUpdated = this.handleFiltersUpdated.bind(this);

    this.form = this.querySelector('form');
    if (!this.form) {
      console.error('FacetFiltersForm: Geen formulier gevonden in component');
      return;
    }

    this.isMobile = this.id === 'FacetFiltersFormMobile';
    console.log(`FacetFiltersForm instance gecreëerd (${this.isMobile ? 'mobile' : 'desktop'})`);

    // Initialiseer lastPriceFilter vanuit URL-parameters bij het laden
    const urlParams = new URLSearchParams(window.location.search);
    const minPriceFromURL = urlParams.get('filter.v.price.gte');
    const maxPriceFromURL = urlParams.get('filter.v.price.lte');
  
    if (minPriceFromURL || maxPriceFromURL) {
      sharedState.lastPriceFilter.min = minPriceFromURL ? parseFloat(minPriceFromURL) : null;
      sharedState.lastPriceFilter.max = maxPriceFromURL ? parseFloat(maxPriceFromURL) : null;
    }
    
    // Gebruik huidige URL-parameters voor initiële range
    const initialSearchParams = urlParams.toString();
    this.initializeGlobalPriceRange(initialSearchParams).then(() => {
      this.syncSliders();
    });

    this.isProgrammaticUpdate = false;
    this.isPriceFilterUpdate = false;
    this.updateInProgress = false;

    this.debouncedOnSubmit = debounce((eventData) => {
      console.log('debouncedOnSubmit aangeroepen voor event:', eventData.targetId);
      this.onSubmitHandler(eventData);
    }, 800);

    this.form.addEventListener('input', (event) => {
      const target = event.target;
      const isPriceInput = target.id === "price-min" || target.id === "price-max" ||
                          target.id === "price-slider-min" || target.id === "price-slider-max";
      console.log('Input event ontvangen:', target.id, 'isPriceInput:', isPriceInput);
      if (!this.isProgrammaticUpdate) {
        this.debouncedOnSubmit({ targetId: target.id, isPriceChange: isPriceInput, originalEvent: event });
      }
    });

    this.form.addEventListener('change', (event) => {
      const target = event.target;
      const isPriceInput = target.id === "price-min" || target.id === "price-max" ||
                          target.id === "price-slider-min" || target.id === "price-slider-max" ||
                          (event.detail && event.detail.isPriceChange);
      console.log('Change event ontvangen op formulier:', target.id, 'isPriceInput:', isPriceInput);
      if (!this.isProgrammaticUpdate) {
        this.debouncedOnSubmit({ targetId: target.id, isPriceChange: isPriceInput, originalEvent: event });
      }
    });

    this.form.addEventListener('reset', () => {
      console.log('Formulier reset gedetecteerd, reset lastPriceFilter en currentPriceRange');
      sharedState.lastPriceFilter.min = null;
      sharedState.lastPriceFilter.max = null;
      sharedState.currentPriceRange.min = sharedState.originalPriceRange.min;
      sharedState.currentPriceRange.max = sharedState.originalPriceRange.max;
      sharedState.dynamicPriceRange.min = sharedState.originalPriceRange.min;
      sharedState.dynamicPriceRange.max = sharedState.originalPriceRange.max;
      this.syncSliders();
    });

    document.removeEventListener('filters-updated', this.handleFiltersUpdated);
    document.addEventListener('filters-updated', this.handleFiltersUpdated);
  }

  async initializeGlobalPriceRange(searchParams = '') {
    try {
      const range = await this.fetchPriceRangeFromAPI(searchParams);
      sharedState.originalPriceRange = range;
      sharedState.currentPriceRange = { ...range };
      sharedState.dynamicPriceRange = { ...range };
      console.log('Globale prijsrange geïnitialiseerd via API met searchParams:', searchParams, range);
    } catch (error) {
      console.error('Fout bij het ophalen van globale prijsrange via API:', error);
      sharedState.originalPriceRange = { min: 0, max: 800 };
      sharedState.currentPriceRange = { min: 0, max: 800 };
      sharedState.dynamicPriceRange = { min: 0, max: 800 };
    }
  }

  async fetchPriceRangeFromAPI(searchParams = '') {
    let allPrices = [];
    let hasNextPage = true;
    let cursor = null;
    const queryString = ' '; // Blijft leeg om alle producten op te halen (voor nu)
  
    console.log('Starting fetchPriceRangeFromAPI with searchParams:', searchParams);
  
    while (hasNextPage) {
      const query = `
        query {
          products(first: 250${queryString}${cursor ? `, after: "${cursor}"` : ''}) {
            edges {
              node {
                title
                priceRange {
                  minVariantPrice { amount }
                  maxVariantPrice { amount }
                }
                metafields(identifiers: [{namespace: "custom", key: "interesse"}]) {
                  key
                  value
                }
                tags
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `;
  
      console.log('API-query uitgevoerd:', query);
  
      const response = await fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
        },
        body: JSON.stringify({ query })
      });
  
      const { data, errors } = await response.json();
      if (errors) {
        console.error('GraphQL-fouten:', JSON.stringify(errors, null, 2));
        throw new Error('API-query mislukt');
      }
  
      if (!data?.products?.edges?.length) {
        console.warn('Geen producten gevonden via API voor query:', queryString);
        break; // Stop de loop als er geen producten zijn
      }
  
      const products = data.products.edges.map(edge => ({
        title: edge.node.title,
        minPrice: parseFloat(edge.node.priceRange.minVariantPrice.amount),
        maxPrice: parseFloat(edge.node.priceRange.maxVariantPrice.amount),
        interesse: edge.node.metafields?.find(m => m?.key === 'interesse')?.value || null,
        tags: edge.node.tags || []
      }));
  
      console.log('Gevonden producten met interesse en tags (eerste 5):', 
        products.slice(0, 5).map(p => ({ title: p.title, interesse: p.interesse, tags: p.tags })));
      console.log('Totaal aantal producten:', products.length);
  
      const parsedProducts = products.map(product => ({
        ...product,
        interesse: typeof product.interesse === 'string' ? JSON.parse(product.interesse) : product.interesse
      }));
  
      // Parse searchParams, maar negeer prijsfilters voor de range
      const params = new URLSearchParams(searchParams);
      const interesseFilters = [];
      const tagFilters = [];
  
      params.forEach((value, key) => {
        if (key === 'filter.p.m.custom.interesse') {
          interesseFilters.push(decodeURIComponent(value));
        } else if (key === 'filter.p.tag') {
          tagFilters.push(decodeURIComponent(value));
        }
      });
  
      console.log('Geselecteerde interesse-filters:', interesseFilters);
      console.log('Geselecteerde tag-filters:', tagFilters);
      console.log('Prijsfilters worden genegeerd voor range-berekening');
  
      // Filter producten alleen op niet-prijsfilters
      const filteredProducts = parsedProducts.filter(product => {
        const matchesInteresse = interesseFilters.length === 0 || 
          (Array.isArray(product.interesse) && interesseFilters.some(filter => product.interesse.includes(filter)));
        const matchesTags = tagFilters.length === 0 || 
          tagFilters.some(tag => product.tags.includes(tag));
  
        return matchesInteresse && matchesTags;
      });
  
      console.log('Gefilterde producten (eerste 5):', 
        filteredProducts.slice(0, 5).map(p => ({ title: p.title, interesse: p.interesse, tags: p.tags })));
      console.log('Totaal aantal gefilterde producten:', filteredProducts.length);
  
      const prices = filteredProducts.map(product => 
        product.minPrice === product.maxPrice ? [product.minPrice] : [product.minPrice, product.maxPrice]
      ).flat();
  
      allPrices = [...allPrices, ...prices];
      hasNextPage = data.products.pageInfo.hasNextPage;
      cursor = data.products.pageInfo.endCursor;
    }
  
    if (!allPrices.length) {
      console.warn('Geen geldige prijzen gevonden na API-paginering');
      return { min: sharedState.originalPriceRange.min, max: sharedState.originalPriceRange.max };
    }
  
    const uniquePrices = [...new Set(allPrices)];
    const minPrice = Math.floor(Math.min(...uniquePrices));
    const maxPrice = Math.ceil(Math.max(...uniquePrices));
  
    console.log('Prijzen opgehaald via API:', uniquePrices);
    console.log(`Prijsrange berekend: ${minPrice} - ${maxPrice}`);
    return { min: minPrice, max: maxPrice };
  }

  convertSearchParamsToQuery(searchParams) {
    const params = new URLSearchParams(searchParams);
    const filters = [];
    params.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        const filterKey = key.replace('filter.p.m.custom.', '');
        filters.push(`custom.${filterKey}:${decodeURIComponent(value)}`);
      }
    });
    const query = filters.join(' ');
    console.log('Geconverteerde searchParams naar query:', query);
    return query;
  }

  handleFiltersUpdated(event) {
    if (this.updateInProgress) {
      console.log(`Extra filters-updated trigger genegeerd (${this.isMobile ? 'mobile' : 'desktop'})`);
      return;
    }

    this.updateInProgress = true;
    console.log(`handleFiltersUpdated triggered (${this.isMobile ? 'mobile' : 'desktop'}), isPriceFilterUpdate:`, this.isPriceFilterUpdate, 'event:', event);

    if (this.isPriceFilterUpdate) {
      console.log('Prijsfilter update gedetecteerd, synchroniseer sliders met dynamische range');
      this.syncSliders();
      this.isPriceFilterUpdate = false;
    } else {
      console.log('Geen prijsfilter update, synchroniseer sliders met huidige dynamische range');
      this.syncSliders();
    }

    this.updateInProgress = false;
  }

  syncSliders() {
    const minSliders = document.querySelectorAll('#price-slider-min, #FacetFiltersFormMobile #price-slider-min');
    const maxSliders = document.querySelectorAll('#price-slider-max, #FacetFiltersFormMobile #price-slider-max');
    const minInputs = document.querySelectorAll('#price-min, #FacetFiltersFormMobile #price-min');
    const maxInputs = document.querySelectorAll('#price-max, #FacetFiltersFormMobile #price-max');
  
    if (!minSliders.length || !maxSliders.length || !minInputs.length || !maxInputs.length) {
      console.warn('Prijsfilter-elementen niet gevonden in DOM');
      return;
    }
  
    this.isProgrammaticUpdate = true;
  
    const effectiveMin = sharedState.lastPriceFilter.min !== null && sharedState.lastPriceFilter.min !== undefined 
      ? parseFloat(sharedState.lastPriceFilter.min) 
      : sharedState.dynamicPriceRange.min;
    const effectiveMax = sharedState.lastPriceFilter.max !== null && sharedState.lastPriceFilter.max !== undefined 
      ? parseFloat(sharedState.lastPriceFilter.max) 
      : sharedState.dynamicPriceRange.max;
  
    // Valideer prijsrange
    let finalMin = Math.max(effectiveMin, sharedState.dynamicPriceRange.min);
    let finalMax = Math.min(effectiveMax, sharedState.dynamicPriceRange.max);
    if (finalMax < finalMin) {
      console.log(`syncSliders: Correcting invalid price range - max (${finalMax}) < min (${finalMin})`);
      finalMax = finalMin;
    }
    
    sharedState.currentPriceRange.min = finalMin;
    sharedState.currentPriceRange.max = finalMax;
  
    minSliders.forEach((minSlider) => {
      minSlider.min = sharedState.dynamicPriceRange.min;
      minSlider.max = sharedState.dynamicPriceRange.max;
      minSlider.value = finalMin;
    });
  
    maxSliders.forEach((maxSlider) => {
      maxSlider.min = sharedState.dynamicPriceRange.min;
      maxSlider.max = sharedState.dynamicPriceRange.max;
      maxSlider.value = finalMax;
    });
  
    minInputs.forEach((minInput) => {
      minInput.min = sharedState.dynamicPriceRange.min;
      minInput.max = sharedState.dynamicPriceRange.max;
      minInput.value = finalMin;
    });
  
    maxInputs.forEach((maxInput) => {
      maxInput.min = sharedState.dynamicPriceRange.min;
      maxInput.max = sharedState.dynamicPriceRange.max;
      maxInput.value = finalMax;
    });
  
    this.isProgrammaticUpdate = false;
  
    console.log(`Sliders gesynchroniseerd (${this.isMobile ? 'mobile' : 'desktop'}) - min:`, finalMin, 'max:', finalMax, 
                'dynamicRange:', sharedState.dynamicPriceRange);
  
    const priceRange = document.querySelector('price-range');
    if (priceRange) priceRange.updateFill();
  }

  static async updatePriceRange(html, event) {
    const isPriceChange = event && event.target && (
      event.target.id === "price-min" || 
      event.target.id === "price-max" || 
      event.target.id === "price-slider-min" || 
      event.target.id === "price-slider-max" ||
      (event.detail && event.detail.isPriceChange)
    );
  
    console.log('updatePriceRange aangeroepen, isPriceChange:', isPriceChange);
  
    try {
      const searchParams = event?.originalEvent?.searchParams || new URLSearchParams(window.location.search).toString();
      const instance = document.querySelector('facet-filters-form');
      if (!instance) {
        console.error('Geen facet-filters-form instantie gevonden voor API-aanroep');
        return;
      }
  
      // Maak een kopie van searchParams zonder prijsfilters
      const params = new URLSearchParams(searchParams);
      const nonPriceParams = new URLSearchParams();
  
      // Gebruik append in plaats van set om meerdere waarden van dezelfde key te behouden
      params.forEach((value, key) => {
        if (key !== 'filter.v.price.gte' && key !== 'filter.v.price.lte') {
          nonPriceParams.append(key, value); // append behoudt meerdere waarden
        }
      });
  
      // Update de dynamische range alleen bij niet-prijsveranderingen
      if (!isPriceChange) {
        const priceRange = await instance.fetchPriceRangeFromAPI(nonPriceParams.toString());
        sharedState.dynamicPriceRange.min = priceRange.min;
        sharedState.dynamicPriceRange.max = priceRange.max;
        sharedState.currentPriceRange.min = priceRange.min;
        sharedState.currentPriceRange.max = priceRange.max;
        console.log(`Dynamische prijsrange bijgewerkt via API met non-price searchParams ${nonPriceParams.toString()}: ${priceRange.min} - ${priceRange.max}`);
      }
  
      const instances = document.querySelectorAll('facet-filters-form');
      instances.forEach(instance => {
        instance.isProgrammaticUpdate = true;
        instance.syncSliders();
        instance.isProgrammaticUpdate = false;
      });
    } catch (error) {
      console.error('Fout bij het updaten van prijsrange via API:', error);
    }
  }

  // Overige methoden blijven onveranderd
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('renderPage aangeroepen met searchParams:', searchParams);
    console.log('Vorige searchParams:', FacetFiltersForm.searchParamsPrev);
    FacetFiltersForm.searchParamsPrev = searchParams;
  
    console.log('Voor getSections aanroep');
    const sections = FacetFiltersForm.getSections();
    console.log('renderPage: sections:', sections);
  
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      productGridContainer.querySelector('.collection')?.classList.add('loading');
    } else {
      console.warn('ProductGridContainer niet gevonden');
    }
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');
  
    sections.forEach((section) => {
      if (!section.section) {
        console.warn('Geen geldige section ID, skipping render');
        return;
      }
  
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => {
        const newUrlObj = new URL(url, window.location.origin);
        const cachedUrlObj = new URL(element.url, window.location.origin);
  
        // Vergelijk de volledige querystring, gesorteerd om consistentie te garanderen
        const newParams = new URLSearchParams(newUrlObj.search);
        const cachedParams = new URLSearchParams(cachedUrlObj.search);
        const sortedNewParams = new URLSearchParams([...newParams.entries()].sort()).toString();
        const sortedCachedParams = new URLSearchParams([...cachedParams.entries()].sort()).toString();
  
        const matches = newUrlObj.pathname === cachedUrlObj.pathname &&
                        sortedNewParams === sortedCachedParams;
  
        console.log('filterDataUrl vergelijking:', {
          newUrl: url,
          cachedUrl: element.url,
          matches: matches,
          newParams: sortedNewParams,
          cachedParams: sortedCachedParams
        });
  
        return matches;
      };
  
      console.log('Vergelijking in filterDataUrl:', {
        newUrl: url,
        cacheUrls: FacetFiltersForm.filterData.map(item => item.url)
      });
  
      const prevCount = countContainer?.textContent.trim();
      const isNoResults = prevCount === '0' || !productGridContainer?.querySelector('.collection > *');
      if (isNoResults || !FacetFiltersForm.filterData.some(filterDataUrl)) {
        console.log('Geen cache-hit of geen resultaten eerder, forceer fetch voor URL:', url);
        FacetFiltersForm.renderSectionFromFetch(url, event);
      } else {
        console.log('Cache-hit, gebruik cache voor URL:', url);
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      }
    });
  
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  
    event.originalEvent = event.originalEvent || {};
    event.originalEvent.searchParams = searchParams;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.updatePriceRange(html, event);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.updatePriceRange(html, event);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML || '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    console.log('renderFilters aangeroepen');
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`)?.before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event?.target.closest('.js-filter')?.id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event?.target.getAttribute('type') === 'text';
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    document.dispatchEvent(new Event('filters-updated'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (activeFacetsElement) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      const element = html.querySelector(selector);
      if (element) {
        document.querySelector(selector).innerHTML = element.innerHTML;
      }
    });
    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const sectionElement = document.getElementById('product-grid');
    console.log('getSections: sectionElement:', sectionElement); // Debug of dit null is
    if (!sectionElement || !sectionElement.dataset.id) {
      console.warn('Geen #product-grid element of dataset.id gevonden, gebruik fallback sectie-ID');
      return [
        {
          section: 'template--24139457855835__product-grid',
        },
      ];
    }
    console.log('Gevonden section ID:', sectionElement.dataset.id);
    return [
      {
        section: sectionElement.dataset.id,
      },
    ];
  }

  onSubmitHandler(eventData) {
    eventData.originalEvent.preventDefault();
  
    if (!this.form) {
      console.error('onSubmitHandler: Geen geldig formulier beschikbaar');
      return;
    }
  
    const formData = new FormData(this.form);
    const { targetId, isPriceChange } = eventData;
  
    // Haal de huidige URL-parameters op om bestaande filters te behouden
    const currentParams = new URLSearchParams(window.location.search);
  
    // Update lastPriceFilter alleen bij een prijsverandering
    if (isPriceChange) {
      this.isPriceFilterUpdate = true;
      const minPrice = this.form.querySelector('#price-min')?.value || 
                       this.form.querySelector('#FacetFiltersFormMobile #price-min')?.value;
      const maxPrice = this.form.querySelector('#price-max')?.value || 
                       this.form.querySelector('#FacetFiltersFormMobile #price-max')?.value;
  
      sharedState.lastPriceFilter.min = minPrice || null;
      sharedState.lastPriceFilter.max = maxPrice || null;
  
      if (minPrice) formData.set('filter.v.price.gte', minPrice);
      else formData.delete('filter.v.price.gte');
      if (maxPrice) formData.set('filter.v.price.lte', maxPrice);
      else formData.delete('filter.v.price.lte');
    } else {
      // Verwijder prijsfilters uit formData als er geen prijsverandering is
      formData.delete('filter.v.price.gte');
      formData.delete('filter.v.price.lte');
      // Behoud bestaande prijsfilters alleen als ze al in de URL zaten
      if (currentParams.has('filter.v.price.gte')) formData.set('filter.v.price.gte', currentParams.get('filter.v.price.gte'));
      if (currentParams.has('filter.v.price.lte')) formData.set('filter.v.price.lte', currentParams.get('filter.v.price.lte'));
    }
  
    // Behoud bestaande filters (zoals interesse) door ze te mergen met formData
    currentParams.forEach((value, key) => {
      if (!formData.has(key) && key !== 'filter.v.price.gte' && key !== 'filter.v.price.lte') {
        formData.set(key, value);
      }
    });
  
    const searchParams = new URLSearchParams(formData).toString();
    console.log('Filter toegepast met params:', searchParams);
    console.log(`onSubmitHandler voor renderPage (${this.isMobile ? 'mobile' : 'desktop'}), currentPriceRange:`, sharedState.currentPriceRange, 'lastPriceFilter:', sharedState.lastPriceFilter);
  
    FacetFiltersForm.renderPage(searchParams, eventData.originalEvent, true);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}